export const httpStatusCode = {
    OK: 200,
    BadRequest: 400,
    InternalServerError: 500
}